import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    AbstractControl,
    FormControlStatus,
    NonNullableFormBuilder,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { startWith, Subject, takeUntil } from 'rxjs';
import { SummaryService } from 'src/app/shared/services';
import { InvalidFieldComponent } from '../field-error/field-error.component';
import { NotesFormErrorJSON, NotesFormGroupType } from './models/notes-form';
import { formNotesErrors } from './utils/form-errors';

@Component({
    selector: 'app-lib-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, ReactiveFormsModule, MatCheckboxModule, MatDividerModule, InvalidFieldComponent],
})
export class NotesComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void> = new Subject<void>();
    public notesForm: NotesFormGroupType;
    public formError: NotesFormErrorJSON;

    @Input() notesText: string;
    @Input() showError: boolean = false;
    @Input() showCheckbox: boolean = true;

    get notes(): AbstractControl | null {
        return this.notesForm.get('notes');
    }

    constructor(
        private fb: NonNullableFormBuilder,
        private summaryService: SummaryService
    ) {}

    ngOnInit(): void {
        this.createForm();
        this.setFormError();
        this.subscribeFormChanges();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    createForm(): void {
        const validators = this.showCheckbox ? [Validators.requiredTrue] : [];
        this.notesForm = this.fb.group({
            notes: [false, validators],
        });
    }

    setFormError(): void {
        this.formError = formNotesErrors;
    }

    subscribeFormChanges(): void {
        this.notesForm.statusChanges
            .pipe(startWith(this.notesForm.status), takeUntil(this.unsubscribe$))
            .subscribe((statusChanges: FormControlStatus) => {
                this.summaryService.setNotesValid({
                    isValidForm: statusChanges === 'VALID',
                    notesFormGroup: this.notesForm,
                });
            });
    }
}
